import React, { FC } from 'react';

import { FormattedMessage } from 'react-intl';

import { IAdditionalInformation } from './additional-information.interface';
import styles from './additional-information.module.scss';

import { Divider, Text } from 'views/components/UI';
import { DialogStack } from 'views/components/UI/Modal';

const AdditionalInformation: FC<IAdditionalInformation> = props => {
  const {
    updatedDate,
    createdDate,
    accountUpdatedBy,
    accountCreatedBy,
    divider,
    topDivider = true,
  } = props;
  return (
    <DialogStack>
      {divider && topDivider && <Divider />}
      <ul className={styles['edit-info']}>
        <li>
          <DialogStack compact>
            <Text variant="label">
              <FormattedMessage id="knowledge-area.modal.settings.created-by" />
            </Text>
            <Text>{accountCreatedBy}</Text>
          </DialogStack>
        </li>
        <li>
          <DialogStack compact>
            <Text variant="label">
              <FormattedMessage id="knowledge-area.modal.settings.created-on" />
            </Text>
            <Text>{createdDate}</Text>
          </DialogStack>
        </li>
      </ul>
      {divider && <Divider />}
      <ul className={styles['edit-info']}>
        <li>
          <DialogStack compact>
            <Text variant="label">
              <FormattedMessage id="knowledge-area.modal.settings.last-edited-by" />
            </Text>
            <Text>{accountUpdatedBy}</Text>
          </DialogStack>
        </li>
        <li>
          <DialogStack compact>
            <Text variant="label">
              <FormattedMessage id="knowledge-area.modal.settings.last-edited-on" />
            </Text>
            <Text>{updatedDate}</Text>
          </DialogStack>
        </li>
      </ul>
    </DialogStack>
  );
};

export { AdditionalInformation };
